import React, { Component, useState } from "react";

import Range from "../../common/Range";

const ADJUSTMENT_SLIDERS = [
  {
    attribute: "whiteHueAdjustment",
    name: "White",
    min: -100,
    max: 100,
    step: 1,
    type: "Hue",
  },
  {
    attribute: "redHueAdjustment",
    name: "Red",
    min: -100,
    max: 100,
    step: 1,
    type: "Hue",
  },
  {
    attribute: "orangeHueAdjustment",
    name: "Orange",
    min: -100,
    max: 100,
    step: 1,
    type: "Hue",
  },
  {
    attribute: "yellowHueAdjustment",
    name: "Yellow",
    min: -100,
    max: 100,
    step: 1,
    type: "Hue",
  },
  {
    attribute: "greenHueAdjustment",
    name: "Green",
    min: -100,
    max: 100,
    step: 1,
    type: "Hue",
  },
  {
    attribute: "aquaHueAdjustment",
    name: "Aqua",
    min: -100,
    max: 100,
    step: 1,
    type: "Hue",
  },
  {
    attribute: "blueHueAdjustment",
    name: "Blue",
    min: -100,
    max: 100,
    step: 1,
    type: "Hue",
  },
  {
    attribute: "purpleHueAdjustment",
    name: "Purple",
    min: -100,
    max: 100,
    step: 1,
    type: "Hue",
  },
  {
    attribute: "magentaHueAdjustment",
    name: "Magenta",
    min: -100,
    max: 100,
    step: 1,
    type: "Hue",
  },

  {
    attribute: "whiteSaturationAdjustment",
    name: "White",
    min: -100,
    max: 100,
    step: 1,
    type: "Saturation",
  },
  {
    attribute: "redSaturationAdjustment",
    name: "Red",
    min: -100,
    max: 100,
    step: 1,
    type: "Saturation",
  },
  {
    attribute: "orangeSaturationAdjustment",
    name: "Orange",
    min: -100,
    max: 100,
    step: 1,
    type: "Saturation",
  },
  {
    attribute: "yellowSaturationAdjustment",
    name: "Yellow",
    min: -100,
    max: 100,
    step: 1,
    type: "Saturation",
  },
  {
    attribute: "greenSaturationAdjustment",
    name: "Green",
    min: -100,
    max: 100,
    step: 1,
    type: "Saturation",
  },
  {
    attribute: "aquaSaturationAdjustment",
    name: "Aqua",
    min: -100,
    max: 100,
    step: 1,
    type: "Saturation",
  },
  {
    attribute: "blueSaturationAdjustment",
    name: "Blue",
    min: -100,
    max: 100,
    step: 1,

    type: "Saturation",
  },
  {
    attribute: "purpleSaturationAdjustment",
    name: "Purple",
    min: -100,
    max: 100,
    step: 1,
    type: "Saturation",
  },
  {
    attribute: "magentaSaturationAdjustment",
    name: "Magenta",
    min: -100,
    max: 100,
    step: 1,
    type: "Saturation",
  },
  {
    attribute: "whiteLuminanceAdjustment",
    name: "White",
    min: -100,
    max: 100,
    step: 1,
    type: "Luminance",
  },
  {
    attribute: "redLuminanceAdjustment",
    name: "Red",
    min: -100,
    max: 100,
    step: 1,
    type: "Luminance",
  },
  {
    attribute: "orangeLuminanceAdjustment",
    name: "Orange",
    min: -100,
    max: 100,
    step: 1,
    type: "Luminance",
  },
  {
    attribute: "yellowLuminanceAdjustment",
    name: "Yellow",
    min: -100,
    max: 100,
    step: 1,
    type: "Luminance",
  },
  {
    attribute: "greenLuminanceAdjustment",
    name: "Green",
    min: -100,
    max: 100,
    step: 1,
    type: "Luminance",
  },
  {
    attribute: "aquaLuminanceAdjustment",
    name: "Aqua",
    min: -100,
    max: 100,
    step: 1,
    type: "Luminance",
  },
  {
    attribute: "blueLuminanceAdjustment",
    name: "Blue",
    min: -100,
    max: 100,
    step: 1,
    type: "Luminance",
  },
  {
    attribute: "purpleLuminanceAdjustment",
    name: "Purple",
    min: -100,
    max: 100,
    step: 1,
    type: "Luminance",
  },
  {
    attribute: "magentaLuminanceAdjustment",
    name: "Magenta",
    min: -100,
    max: 100,
    step: 1,
    type: "Luminance",
  },
];

const HSL = (props) => {
  let { hsl, filter, onUpdated, onFilterUpdated } = props;

  const [selectedColor, setSelectedColor] = useState(
    ADJUSTMENT_SLIDERS[0].name
  );

  const renderColor = (color) => {
    let colorCSS = "color";
    if(selectedColor === color){
      colorCSS += " active";
    }
    return (
      <div
        className={colorCSS}
        style={{
          borderColor: color,
        }}
      >
        <div
          className=""
          key={color}
          style={{
            backgroundColor: color,
          }}
          onClick={() => setSelectedColor(color)}
        ></div>
      </div>
    );
  };

  const renderSlider = (slider) => {
    const name = slider.name.toLowerCase();
    const type = slider.type.toLowerCase();

    let data = filter.data || {}
    const value = name === "white" ? hsl[type] : data[slider.attribute];

    return (
      <div key={slider.attribute} className="row my-1">
        <div className="d-flex justify-content-between">
          <div>{slider.type}</div>
          <div>{value || 0}</div>
        </div>
        <div className="col-12">
          <Range
            value={value || 0}
            min={slider?.min}
            max={slider?.max}
            step={slider?.step}
            onChange={(e) => {
              const name = slider.name.toLowerCase();
              const type = slider.type.toLowerCase();

              if (name === "white") {
                hsl[type] = parseFloat(e.target.value);

                onUpdated(hsl);
              } else {
                let data = filter.data || {}
                data[slider.attribute] = parseFloat(e.target.value);
                filter.data = data
                onFilterUpdated(filter);
              }
            }}
          />
        </div>
      </div>
    );
  };

  const uniqueColors = Array.from(
    new Set(
      ADJUSTMENT_SLIDERS.filter((slider) => slider.name).map(
        (slider) => slider.name
      )
    )
  );

  return (
    <>
      <div className="colors">
        {uniqueColors.map((color) => renderColor(color))}
      </div>
      <div className="sliders">
        {ADJUSTMENT_SLIDERS.map((slider, index) => {
          return slider.name === selectedColor && renderSlider(slider);
        })}
      </div>
    </>
  );
};

export default HSL;
